// extracted by mini-css-extract-plugin
module.exports = {"bottomMenu":"index-module--bottom-menu--wLBa2","copyright":"index-module--copyright--1QyY_"};